import { icons } from 'assets/icons/index';
import { GenericModal } from 'components/Modals/GenericModal';
import { CollapsibleList } from 'components/CollapsibleList';

type ProcessingErrorModalType = {
  errors: string[];
  onClose: () => void;
  objectTitle: string;
};

export default function ErrorModal({ errors, onClose, objectTitle }: ProcessingErrorModalType) {

  return (
    <GenericModal
      title={`Error in Uploading ${objectTitle}`}
      roundIconStyle={false}
      icon={<icons.ErrorIcon aria-label='error' width="40px" height="40px" />}
      isOpen
      cancelName={'OK'}
      onCancel={onClose}
    >
      <p>Sorry, your upload was unsuccessful. Please check your file.</p>
      <CollapsibleList
        boldErrors={false}
        label={`Errors`}
        items={errors}
      />
    </GenericModal>
  );
}
